module.exports = __webpack_public_path__ + "img/earth.661de25.svg";